/**
 * @desc createOrUpdate
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.AllocationBatchCreateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/allocationBatch/createOrUpdate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
